/* Solo-Air · Warenkorb: Upsell "+ Hinzufügen" (Drawer + Warenkorbseite) */
(function () {
  if (window.__saCartInit) return;
  window.__saCartInit = true;

  // Falls der Header cart-drawer.js nicht lädt, nachladen (nur wenn Drawer vorhanden)
  function ensureDrawerScript() {
    if (!document.querySelector('cart-drawer')) return;
    if (window.customElements && customElements.get('cart-drawer')) return;
    if (!window.saCartDrawerJs || document.querySelector('script[data-sa-drawer]')) return;
    var s = document.createElement('script');
    s.src = window.saCartDrawerJs;
    s.defer = true;
    s.setAttribute('data-sa-drawer', '1');
    document.head.appendChild(s);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(ensureDrawerScript, 1200); });
  } else {
    setTimeout(ensureDrawerScript, 1200);
  }

  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    return base.replace(/\.js$/, '') + '.js';
  }

  function resetBtn(btn, text) {
    btn.classList.remove('is-loading');
    if (text) {
      btn.disabled = true;
      btn.classList.add('is-off');
      btn.setAttribute('title', text);
      btn.setAttribute('aria-label', text);
    } else {
      btn.disabled = false;
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sa-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var variantId = parseInt(btn.getAttribute('data-sa-add'), 10);
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.getElementById('main-cart-items') && !btn.closest('cart-drawer');
    var body = { items: [{ id: variantId, quantity: 1 }] };
    var useDrawer = drawer && !onCartPage && typeof drawer.renderContents === 'function';
    if (useDrawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }

    fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.status !== 200) {
          resetBtn(btn, 'Nicht verfügbar');
          return;
        }
        if (useDrawer && res.sections) {
          drawer.renderContents(res);
          document.dispatchEvent(new CustomEvent('sa:cart:added', { detail: { variantId: variantId } }));
        } else {
          window.location.reload();
        }
      })
      .catch(function () { resetBtn(btn); });
  });
})();